import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { CommissionHoldRelease } from '../model/commission-hold-release.model';
import { CreditHoldReleaseStatus } from '../model/credit-hold-release-status.model';
import { CommissionHoldReleaseRequest } from '../model/commission-hold-release-request.model';

@Injectable({
  providedIn: 'root',
})
export class CommissionHoldReleaseService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.services_url;
  }

  /**
   * Valida una lista de créditos contra el estado actual de retenciones/liberaciones.
   * El backend evalúa según el userRoleId del usuario logueado.
   * @param ids - Lista de iCreditId
   */
  validateCreditHoldRelease(ids: (number | undefined)[]): Observable<CreditHoldReleaseStatus[]> {
    const userRoleId = localStorage.getItem('com_role');
    return this.http.post<CreditHoldReleaseStatus[]>(`${this.url}/retenciones/validarRetencionLiberacion/${userRoleId}`, ids);
  }

  /**
  * Guarda las retenciones o liberaciones validadas.
  */
  saveCommissionHoldRelease(payload: CommissionHoldReleaseRequest[]): Observable<any> {
    return this.http.post(`${this.url}/retenciones/guardarRetencionLiberacion`, payload, { responseType: 'text' });
  }

  getCommissionByFilters(requestObject: any) {
    return this.http.post<CommissionHoldRelease[]>(
      `${this.url}/reportesRetenciones/findCommissionHoldRelease`,
      requestObject
    );
  }

  getApplyPaymentComision(idCredito: number) {
    return this.http.get<CommissionHoldRelease[]>(
      `${this.url}/reportesRetenciones/findCommissionCreditInfo?iCreditId=${idCredito}`
    );
  }

  getListCommissionHoldRelease(listIdsCredit: any[], type: number) {
    const userRoleId = localStorage.getItem('com_role');
    return this.http.post<CommissionHoldRelease[]>(
      `${this.url}/CommissionsHoldRelease/findAllHoldReleaseXIds/${userRoleId}?type=${type}`,
      listIdsCredit
    );
  }

  validateUsuarioRetencion(idAsesor: string): Observable<CreditHoldReleaseStatus> {
    return this.http.get<CreditHoldReleaseStatus>(
      `${this.url}/retenciones/validarRetencionPorAsesor/${idAsesor}`);
  }

  guardarRetencionPorAsesor(retenciones: any[]): Observable<any> {
    return this.http.post(`${this.url}/retenciones/guardarRetencionLiberacion`, retenciones, { responseType: 'text' });
  }
}